var map = {
	"./btn_add_0.png": "0aa1",
	"./btn_add_1.png": "4384",
	"./btn_add_2.png": "d672",
	"./btn_add_3.png": "e279",
	"./btn_add_photo.png": "f19f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90f9";